var map = {
	"./banner-img.png": 7209,
	"./course-banner-img.png": 8358,
	"./cross.png": 4377,
	"./login-left.png": 9498,
	"./logo-color.png": 7430,
	"./logo-color2.png": 4477,
	"./logo.png": 4427,
	"./logout.png": 6919,
	"./pointer.png": 4485,
	"./tick.png": 4307
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;